/** Spalten-Konfiguration und Sortierung der Announcement-Tabelle (jf-table). */
export const STORAGE_KEY_ADMIN_ANNOUNCEMENT_TABLE = 'admin-announcement-table';

/** Prefix für den External-Link-Dialog Skip-Status (pro URL). */
export const STORAGE_KEY_EXTERNAL_LINK_SKIP_DIALOG = 'external-link-skip-dialog:';

/** Zuletzt gewählte Größe des Assistent-Panels. */
export const STORAGE_KEY_ASSISTANT_PANEL_SIZE = 'assistant-panel-size';
